// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__QIgEQ","pulse":"Skeleton_pulse__ZENvG"};